var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDebitCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 86,
    viewBox: "0 0 145 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15047_21083)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 86,
    rx: 12,
    fill: "url(#paint0_linear_15047_21083)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5799 58.2109H109.506L146 86.9971H-1.00006L32.5799 58.2109Z",
    fill: "url(#paint1_linear_15047_21083)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5067 15.7753C68.5528 15.6837 68.6645 15.6468 68.7561 15.6929L72.3941 17.524C72.4857 17.5701 72.5226 17.6818 72.4765 17.7734L69.1012 24.4793C69.0317 24.6174 68.8336 24.6151 68.7674 24.4752L67.7863 22.4032C67.7499 22.3262 67.6658 22.2839 67.5823 22.3004L65.3336 22.7469C65.1818 22.777 65.0619 22.6193 65.1314 22.4811L68.5067 15.7753Z",
    fill: "#A06700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2733 15.7753C73.2272 15.6837 73.1155 15.6468 73.0238 15.6929L69.3859 17.524C69.2943 17.5701 69.2574 17.6818 69.3035 17.7734L72.6787 24.4793C72.7483 24.6174 72.9464 24.6151 73.0126 24.4752L73.9936 22.4032C74.0301 22.3262 74.1142 22.2839 74.1977 22.3004L76.4464 22.7469C76.5981 22.777 76.7181 22.6193 76.6485 22.4811L73.2733 15.7753Z",
    fill: "#A06700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8056 8.04948C70.4104 7.46433 71.3704 7.46433 71.9752 8.04948C72.3211 8.38409 72.8021 8.54036 73.2786 8.47296C74.1119 8.3551 74.8885 8.91934 75.0339 9.74827C75.1171 10.2223 75.4143 10.6314 75.8394 10.857C76.5829 11.2514 76.8795 12.1644 76.5099 12.9205C76.2986 13.3528 76.2986 13.8585 76.5099 14.2909C76.8795 15.047 76.5829 15.9599 75.8394 16.3544C75.4143 16.5799 75.1171 16.9891 75.0339 17.4631C74.8885 18.292 74.1119 18.8563 73.2786 18.7384C72.8021 18.671 72.3211 18.8273 71.9752 19.1619C71.3704 19.747 70.4104 19.747 69.8056 19.1619C69.4597 18.8273 68.9787 18.671 68.5022 18.7384C67.6689 18.8563 66.8923 18.292 66.7469 17.4631C66.6637 16.9891 66.3665 16.5799 65.9414 16.3544C65.198 15.9599 64.9013 15.047 65.2709 14.2909C65.4823 13.8585 65.4823 13.3528 65.2709 12.9205C64.9013 12.1644 65.198 11.2514 65.9414 10.857C66.3665 10.6314 66.6637 10.2223 66.7469 9.74827C66.8923 8.91934 67.6689 8.3551 68.5022 8.47296C68.9787 8.54036 69.4597 8.38409 69.8056 8.04948Z",
    fill: "#FBB73D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8432 10.8914C72.1148 10.6864 72.5037 10.8818 72.5012 11.2221L72.4915 12.565C72.4905 12.7002 72.5561 12.8272 72.6669 12.9046L73.7676 13.6739C74.0466 13.8689 73.9809 14.2991 73.6564 14.4019L72.3763 14.8076C72.2474 14.8485 72.1469 14.9501 72.1075 15.0794L71.716 16.3639C71.6168 16.6895 71.1873 16.76 70.9893 16.4832L70.2078 15.3911C70.1292 15.2811 70.0015 15.217 69.8664 15.2194L68.5237 15.244C68.1834 15.2503 67.9836 14.8636 68.1857 14.5897L68.9829 13.509C69.0631 13.4003 69.0847 13.259 69.0406 13.1312L68.6023 11.8619C68.4912 11.5401 68.7972 11.2307 69.1201 11.3382L70.3943 11.7624C70.5225 11.8051 70.6635 11.782 70.7714 11.7006L71.8432 10.8914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_15047_21083)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.0979,
    cy: 34.5573,
    r: 11.073,
    fill: "#EED5A9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15047_21083)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5396,
    y: 36.1562,
    width: 52.604,
    height: 17.7462,
    fill: "#2D080C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6134 55.7141V53.9141H95.7694V55.3401H96.6634V56.7704H97.5226V58.1988H41.5438V55.7141H45.6134Z",
    fill: "#762029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0874 35.9219H92.0306V36.5698C92.0306 36.669 91.9503 36.7494 91.8511 36.7494H84.0874V35.9219Z",
    fill: "#D8707E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4598 26.9297L68.7814 26.9811L84.7313 35.9225H92.0305L75.4598 26.9297Z",
    fill: "#EAA8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7401 32.0241C43.7401 31.9331 43.8139 31.8594 43.9049 31.8594L60.0576 31.8594L57.507 33.2876H43.9049C43.8139 33.2876 43.7401 33.2138 43.7401 33.1229V32.0241Z",
    fill: "#D97A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5642 34.8835C44.5642 34.7925 44.638 34.7188 44.729 34.7188L54.9621 34.7188L52.8227 35.9203L52.6719 36.1736L44.7284 36.1475C44.6376 36.1472 44.5642 36.0735 44.5642 35.9828V34.8835Z",
    fill: "#D8707E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5396 33.2891H57.5098L54.9719 34.7173H46.5396V33.2891Z",
    fill: "#B53240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.794 32.0241C100.794 31.9331 100.72 31.8594 100.629 31.8594L84.4765 31.8594L87.0271 33.2876H100.629C100.72 33.2876 100.794 33.2138 100.794 33.1229V32.0241Z",
    fill: "#D97A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9709 34.8835C99.9709 34.7925 99.8972 34.7188 99.8062 34.7188L89.8144 34.7188L92.0309 35.9206V36.1736L99.8067 36.1475C99.8975 36.1472 99.9709 36.0736 99.9709 35.9828V34.8835Z",
    fill: "#D8707E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9946 33.2891H87.0244L89.8236 34.7173H97.9946V33.2891Z",
    fill: "#B53240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.78 26.9766L84.6554 35.8666C85.0773 36.1029 84.9096 36.7457 84.426 36.7457H53.134C52.6504 36.7457 52.4826 36.1029 52.9046 35.8666L68.78 26.9766Z",
    fill: "#D7747E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7791 28.6875L80.6173 35.3167H56.941L68.7791 28.6875Z",
    fill: "#EAA8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0803 36.75H84.4772V37.7087C84.4772 37.968 84.267 38.1782 84.0077 38.1782H53.5498C53.2905 38.1782 53.0803 37.968 53.0803 37.7087V36.75Z",
    fill: "#CB4856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0803 54.3836C53.0803 54.1243 53.2905 53.9141 53.5498 53.9141H84.0077C84.267 53.9141 84.4772 54.1243 84.4772 54.3836V55.3423H53.0803V54.3836Z",
    fill: "#D97A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3347 55.8133C51.3347 55.554 51.5449 55.3438 51.8042 55.3438H85.7558C86.0151 55.3438 86.2253 55.554 86.2253 55.8133V56.772H51.3347V55.8133Z",
    fill: "#B53240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9269 57.2351C49.9269 56.9758 50.1371 56.7656 50.3964 56.7656H87.1605C87.4198 56.7656 87.63 56.9758 87.63 57.2351V58.1939H49.9269V57.2351Z",
    fill: "#D97A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6761 38.1719H60.6775V39.1306C60.6775 39.3899 60.4673 39.6001 60.208 39.6001H55.1457C54.8864 39.6001 54.6761 39.3899 54.6761 39.1306V38.1719Z",
    fill: "#85232D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2175 38.1719H68.2188V39.1306C68.2188 39.3899 68.0086 39.6001 67.7493 39.6001H62.687C62.4277 39.6001 62.2175 39.3899 62.2175 39.1306V38.1719Z",
    fill: "#85232D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7595 38.1719H75.7609V39.1306C75.7609 39.3899 75.5507 39.6001 75.2914 39.6001H70.229C69.9697 39.6001 69.7595 39.3899 69.7595 39.1306V38.1719Z",
    fill: "#85232D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3019 38.1719H83.3032V39.1306C83.3032 39.3899 83.093 39.6001 82.8337 39.6001H77.7714C77.5121 39.6001 77.3019 39.3899 77.3019 39.1306V38.1719Z",
    fill: "#85232D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6761 52.9539C54.6761 52.6946 54.8864 52.4844 55.1457 52.4844H60.208C60.4673 52.4844 60.6775 52.6946 60.6775 52.9539V53.9126H54.6761V52.9539Z",
    fill: "#1A3082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2175 52.9539C62.2175 52.6946 62.4277 52.4844 62.687 52.4844H67.7493C68.0086 52.4844 68.2188 52.6946 68.2188 52.9539V53.9126H62.2175V52.9539Z",
    fill: "#85232D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7595 52.9539C69.7595 52.6946 69.9697 52.4844 70.229 52.4844H75.2914C75.5507 52.4844 75.7609 52.6946 75.7609 52.9539V53.9126H69.7595V52.9539Z",
    fill: "#85232D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3019 52.9539C77.3019 52.6946 77.5121 52.4844 77.7714 52.4844H82.8337C83.093 52.4844 83.3032 52.6946 83.3032 52.9539V53.9126H77.3019V52.9539Z",
    fill: "#85232D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8082,
    y: 39.6016,
    width: 3.73909,
    height: 12.8812,
    fill: "url(#paint2_linear_15047_21083)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.3503,
    y: 39.6016,
    width: 3.73909,
    height: 12.8812,
    fill: "url(#paint3_linear_15047_21083)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.8898,
    y: 39.6016,
    width: 3.73909,
    height: 12.8812,
    fill: "url(#paint4_linear_15047_21083)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.4321,
    y: 39.6016,
    width: 3.73909,
    height: 12.8812,
    fill: "url(#paint5_linear_15047_21083)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0776,
    y: 36.1641,
    width: 1.82234,
    height: 17.7462,
    fill: "#5B1920"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.8351,
    y: 36.75,
    width: 1.82234,
    height: 17.1638,
    fill: "#5B1920"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.3212,
    y: 36.1562,
    width: 1.82234,
    height: 17.7579,
    fill: "#5B1920"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.0793,
    y: 36.1562,
    width: 1.82234,
    height: 17.7593,
    fill: "#5B1920"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.322,
    y: 36.75,
    width: 1.82234,
    height: 17.1638,
    fill: "#5B1920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7863 53.9141H106.021C106.28 53.9141 106.49 54.1243 106.49 54.3836V55.3423H95.7863V53.9141Z",
    fill: "#FA4257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6781 55.3438H108.675C108.934 55.3438 109.144 55.554 109.144 55.8133V56.772H96.6781V55.3438Z",
    fill: "#73A8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5423 56.7734H111.01C111.269 56.7734 111.479 56.9836 111.479 57.2429V58.2017H97.5423V56.7734Z",
    fill: "#4882F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5396,
    y: 36.1562,
    width: 1.82234,
    height: 17.7462,
    fill: "#5B1920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4506 57.5942C47.4506 54.7721 45.1628 52.4844 42.3407 52.4844C39.5187 52.4844 37.2309 54.7721 37.2309 57.5942V58.1612H47.4506V57.5942Z",
    fill: "#55060F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3405 58.1627C42.3405 56.6058 41.0784 55.3438 39.5215 55.3438H37.355C35.7982 55.3438 34.5361 56.6058 34.5361 58.1627H42.3405Z",
    fill: "#55060F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9231 57.2649C44.9231 53.2267 48.1967 49.9531 52.2349 49.9531H55.1443C59.6764 49.9531 63.3504 53.6271 63.3504 58.1592H54.1367H44.9231V57.2649Z",
    fill: "#9C1D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9057 57.9907C90.9057 54.6002 93.6543 51.8516 97.0449 51.8516C100.435 51.8516 103.184 54.6002 103.184 57.9907V58.1999H90.9057V57.9907Z",
    fill: "#971C29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.048 58.2005C102.048 56.3811 103.523 54.9062 105.342 54.9062H108.643C110.463 54.9062 111.937 56.3811 111.937 58.2005H102.048Z",
    fill: "#55060F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7111 23.2552C39.7077 23.8466 39.656 25.1912 39.6223 25.5684C39.4879 27.0703 39.2456 27.8069 38.7068 28.3516C38.3985 28.6633 37.907 28.9004 37.3183 29.0214C37.2249 29.0406 37.1006 29.0676 37.0422 29.0813C36.7719 29.1451 35.7398 29.2267 35.1411 29.2317C34.9133 29.2336 34.6695 29.2425 34.5994 29.2515C34.4757 29.2674 34.4787 29.2684 34.7036 29.286C34.8311 29.2959 35.0939 29.304 35.2878 29.3039C35.4817 29.3038 35.7358 29.315 35.8527 29.3287C35.9695 29.3423 36.2041 29.3641 36.3741 29.377C37.6063 29.4703 38.3906 29.7809 38.8612 30.362C39.2933 30.8954 39.5032 31.6136 39.6224 32.9655C39.6581 33.3702 39.708 34.7203 39.708 35.2815C39.708 35.577 39.7118 35.8142 39.7166 35.8085C39.7213 35.8028 39.736 35.364 39.7492 34.8334C39.7953 32.9821 39.8703 32.1914 40.0719 31.4317C40.1176 31.2595 40.1182 31.2579 40.217 31.005C40.4685 30.3613 40.9045 29.9333 41.5666 29.6799C41.7068 29.6262 41.8645 29.5746 41.9171 29.5652C41.9696 29.5557 42.0413 29.5377 42.0764 29.5251C42.1421 29.5015 42.4707 29.4454 42.7879 29.4035C43.1236 29.3592 43.6243 29.3245 44.2217 29.3042C44.987 29.2782 44.9969 29.2775 44.8483 29.2535C44.7841 29.2432 44.5403 29.2333 44.3067 29.2316C43.7239 29.2273 42.6225 29.1399 42.4268 29.0824C42.386 29.0704 42.2999 29.0534 42.2357 29.0445C41.9632 29.0071 41.5035 28.8526 41.2455 28.7118C40.4905 28.2997 40.1122 27.6322 39.9212 26.3751C39.8466 25.8842 39.794 25.1769 39.7702 24.3438C39.7578 23.9083 39.7401 23.3628 39.731 23.1315L39.7143 22.7109L39.7111 23.2552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7778 34.3375C35.776 34.6448 35.7492 35.3435 35.7316 35.5395C35.6618 36.32 35.5359 36.7027 35.256 36.9858C35.0957 37.1477 34.8404 37.2709 34.5344 37.3338C34.4859 37.3438 34.4213 37.3578 34.3909 37.365C34.2505 37.3981 33.7142 37.4405 33.4031 37.4431C33.2847 37.4441 33.158 37.4487 33.1216 37.4534C33.0573 37.4617 33.0589 37.4622 33.1758 37.4713C33.242 37.4765 33.3786 37.4807 33.4793 37.4806C33.58 37.4806 33.7121 37.4864 33.7728 37.4935C33.8335 37.5006 33.9555 37.5119 34.0438 37.5186C34.6841 37.5671 35.0916 37.7285 35.3362 38.0304C35.5607 38.3076 35.6698 38.6808 35.7317 39.3833C35.7503 39.5936 35.7762 40.2952 35.7762 40.5868C35.7762 40.7404 35.7782 40.8636 35.7807 40.8607C35.7831 40.8577 35.7907 40.6297 35.7976 40.3539C35.8216 39.392 35.8605 38.9811 35.9653 38.5863C35.9891 38.4968 35.9893 38.496 36.0407 38.3646C36.1714 38.0301 36.398 37.8077 36.742 37.676C36.8148 37.6481 36.8968 37.6213 36.9241 37.6164C36.9514 37.6115 36.9887 37.6021 37.0069 37.5956C37.041 37.5833 37.2118 37.5541 37.3767 37.5324C37.551 37.5094 37.8112 37.4914 38.1217 37.4808C38.5193 37.4673 38.5245 37.4669 38.4473 37.4545C38.4139 37.4491 38.2873 37.444 38.1658 37.4431C37.863 37.4408 37.2907 37.3954 37.189 37.3655C37.1678 37.3593 37.1231 37.3504 37.0897 37.3459C36.9481 37.3264 36.7092 37.2461 36.5751 37.1729C36.1828 36.9588 35.9862 36.6119 35.887 35.9587C35.8482 35.7036 35.8209 35.3361 35.8085 34.9032C35.8021 34.6769 35.7929 34.3934 35.7881 34.2732L35.7795 34.0547L35.7778 34.3375Z",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 144,
    height: 85,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_15047_21083",
    x: 33.8074,
    y: -2.73318,
    width: 74.581,
    height: 74.5835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.1088,
    result: "effect1_foregroundBlur_15047_21083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15047_21083",
    x1: -72.2326,
    y1: 43.0529,
    x2: 3.14133,
    y2: 170.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D1D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54123C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15047_21083",
    x1: 61.7708,
    y1: 58.2109,
    x2: 63.8947,
    y2: 126.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A1B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#280F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15047_21083",
    x1: 57.6777,
    y1: 39.6016,
    x2: 57.6777,
    y2: 52.4827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE4155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A222B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15047_21083",
    x1: 65.2198,
    y1: 39.6016,
    x2: 65.2198,
    y2: 52.4827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE4155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A222B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15047_21083",
    x1: 72.7594,
    y1: 39.6016,
    x2: 72.7594,
    y2: 52.4827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE4155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A222B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15047_21083",
    x1: 80.3017,
    y1: 39.6016,
    x2: 80.3017,
    y2: 52.4827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE4155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A222B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15047_21083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 86,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15047_21083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.5181,
    height: 35.4227,
    fill: "white",
    transform: "translate(34.0001 22.7109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCard);
export default __webpack_public_path__ + "static/media/Debit-Card.d5353bd0bc4ceb188a6de61a89d2119c.svg";
export { ForwardRef as ReactComponent };